import request from '../utils/request'

const url = '/oil'


// 分页条件查询
export const getList = (params) => {
  return request({
    url: url, method: 'get', params
  })
}

// 更新车号
export const updateCode = (id, updateCode) => {
  return request({
    url: `${url}/updateCode/${id}`,
    method: 'put',
    params: { updateCode }
  })
}

// 导出加油数据
export function exportOil(params) {
  return request({
    url: '/oil/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}
